// frontend/src/components/FinanceReport/Accounting/components/finance-report/FinanceReportTab.jsx

import FinanceOverview from "../../../FinanceOverview";

export default function FinanceReportTab() {
  return (
    <div>
      <div className="mb-4">
        <h2 className="text-lg font-bold text-slate-900">Финансовая отчётность</h2>
        <p className="mt-1 text-sm text-slate-500">
          Доход / расход / прибыль за выбранный период.
        </p>
      </div>
      <FinanceOverview />
    </div>
  );
}